import React, {Component} from 'react';
import logo from './itovault_logo.png';
import './style.css';
import ReadVaultFunction from "./ReadVaultFunction";
import LiquidateCTV from "./LiquidateCTV";
import WithdrawWei from "./WithdrawWei";
import VaultFunctionWithInput from "./VaultFunctionWithInput";
import ClaimFunctionWithInput from "./ClaimFunctionWithInput";
import ReadClaimFunction from "./ReadClaimFunction";



class App extends Component {
  state = { loading: true, drizzleState: null };

  componentDidMount() {
    const { drizzle } = this.props;
	
	document.title = "ItoVault Tools";

    // subscribe to changes in the store
    this.unsubscribe = drizzle.store.subscribe(() => {

      // every time the store updates, grab the state from drizzle
      const drizzleState = drizzle.store.getState();

      // check to see if it's ready, if so, update local component state
      if (drizzleState.drizzleStatus.initialized) {
        this.setState({ loading: false, drizzleState });
      }
    });
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    if (this.state.loading) return "Loading Application: Please ensure web3 (e.g. Metamask) is connected.";
    return (
	
	
		
      <div className="App">
		<link href="//fonts.googleapis.com/css?family=Roboto+Condensed:300,300i,400,400i,700,700i" rel="stylesheet"/>
		<script src='//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js'></script>
		<div class="main">
			<h1>ItoVault Tools</h1>
			<p> This single page contains the main tools to interact with the ItoVault System.
			Please note that if you're just intereted in buying vSPY, you don't <em>need</em> to use this page
			you can go <a href="https://app.uniswap.org/#/swap?outputCurrency=0x3e1e15AFD5d50b090aDcC88160dD84a48EA1B80E">directly here</a>.	</p>
			<hr/>
			<div class="main-w3lsrow">

				<h2>Dashboard</h2>
				<p>This dashboard contains key data about the current state of the ItoVault system.</p>
				
				<div class="login-form login-form-left"> 
					<div class="agile-row">
						<h3>Value of vSPY in ETH</h3> 
						<p class="output-value">Value: <ReadVaultFunction drizzle={this.props.drizzle}	   drizzleState={this.state.drizzleState}  value="weiPervSPY" decimalsToDivide="18"/></p>
						<p>This is the last reported value of vSPY.  That is, this is the number of ETH that has the same value as one vSPY token for purposes of checking margin compliance.</p>

					</div> 
				</div>  
				
				
				
				<div class="login-form agileits-right"> 
					<div class="agile-row">
						<h3>Initial Margin</h3> 
						<p class="output-value">Value: <ReadVaultFunction drizzle={this.props.drizzle}	   drizzleState={this.state.drizzleState}  value="initialLTVE10" decimalsToDivide="8"/>%</p>
						<p>This is the maximum loan-to-value (LTV) ratio allowed by a vault when minting new vSPY. </p>

					</div> 
				</div>
				<div class="clear"> </div>
			</div><br/><br/>
			<div class="main-w3lsrow">
		
				<div class="login-form login-form-left"> 
					<div class="agile-row">
						<h3>Maintenance Margin</h3> 
						<p class="output-value">Value: <ReadVaultFunction drizzle={this.props.drizzle}	   drizzleState={this.state.drizzleState}  value="maintLTVE10" decimalsToDivide="8"/>%</p>
						<p>This is the maximum loan-to-value ratio above which *anyone* can start liquidating your vault and collecting the liquidation penalty.</p>

					</div> 
				</div>  
				
				<div class="login-form agileits-right"> 
					<div class="agile-row">
						<h3>Liquidation Reward</h3> 
						<p class="output-value">Value: <ReadVaultFunction drizzle={this.props.drizzle}	   drizzleState={this.state.drizzleState}  value="liqPenaltyE10" decimalsToDivide="8"/>%</p>
						<p>This is the reward given to anyone who liquidates a vault which is out of margin compliance.</p>

					</div> 
				</div>
				<div class="clear"> </div>
			</div><hr/><br/><br/>
			
			
			<div class="main-w3lsrow">
				<h2>Vault Information</h2>
				<p>This section tells you information about the Vault (CTV) associated with your current web3 address.</p>
		
				<div class="login-form login-form-left"> 
					<div class="agile-row">
						<h3>Your Web3 Address</h3> 
						<p class="output-value">{this.state.drizzleState.accounts[0]}</p>
						<p>This is your connected account's address.</p>

					</div> 
				</div>  
				
				<div class="login-form agileits-right"> 
					<div class="agile-row">
						<h3>ItoVault System Address</h3> 
						<p class="output-value">{this.props.drizzle.contracts.VaultSystem.address}</p>
						<p>This is the address of the ItoVault Smart Contract. You may send ETH to this address and the ETH will be automatically credited to your vault. (factory contract receive() function credits your vault)</p>

					</div> 
				</div>
				<div class="clear"> </div>
			</div><br/><br/>
			
			
			<div class="main-w3lsrow">
				<div class="login-form login-form-left"> 
					<div class="agile-row">
						<h3>Your Vault's vSPY Outstanding</h3> 
						<p class="output-value">
						Value:
						<ReadVaultFunction 
							drizzle={this.props.drizzle}
							drizzleState={this.state.drizzleState}
							value="vSPYDebtE18"
							dictkey={this.state.drizzleState.accounts[0]}
							decimalsToDivide="18"
						/></p>
						<p>This is the number of vSPY your vault (CTV) has issued.  This vSPY is considered debt against your vault, and margin calculations are based on this number.</p>

					</div> 
				</div>  
				
				<div class="login-form agileits-right"> 
					<div class="agile-row">
						<h3>vSPY Token Address</h3> 
						<p class="output-value"><ReadVaultFunction 
						  drizzle={this.props.drizzle}
						  drizzleState={this.state.drizzleState}
						  value="vSPYToken"
						/> </p>
						<p>This is the address of ERC-20 vSPY token.  You can use this to trade vSPY on Uniswap and to run other ERC-20 interface guaranteed smart contract functions.</p>

					</div> 
				</div>
				<div class="clear"> </div>
			</div><br/><br/>
		
			<div class="main-w3lsrow">
				<div class="login-form login-form-left"> 
					<div class="agile-row">
						<h3>Wei in Your Current Vault</h3> 
						<p class="output-value">		
						<ReadVaultFunction 
						  drizzle={this.props.drizzle}
						  drizzleState={this.state.drizzleState}
						  value="weiAsset"
						  dictkey={this.state.drizzleState.accounts[0]}
						/> </p>
						<p>This is the number of Wei in your current vault.  (10^18 Wei = 1 ETH)</p>

					</div>  
				</div>  
				
				<div class="clear"> </div>
			</div><hr/><br/><br/>
	
		
			<div class="main-w3lsrow">
				<h2>Vault Actions</h2>
				<p>This section gives you actions you can perform on the Vault (CTV) associated with your current web3 address.</p>
		
				<div class="login-form login-form-left"> 
					<div class="agile-row">
						<h3>Withdraw Wei from your CTV</h3> 
						<p>Input the number of Wei, as a positive integer, that you want to withdraw from your vault (CTV). Note: you must be in margin compliance *after* the Wei withdrawal in order for the transaction to succeed.</p>
						<VaultFunctionWithInput
						  drizzle={this.props.drizzle}
						  drizzleState={this.state.drizzleState}
						  value="withdrawWEI"
						/>
					</div> 
				</div>  
				
				<div class="login-form agileits-right"> 
					<div class="agile-row">
						<h3>Mint vSPY</h3> 
						<p>Input the number of vSPY you want to mint from your vault, multiplied by 10^18 and expressed as an integer. For example, if you want to mint .07 vSPY tokens, put in 70000000000000000 (seven followed by 16 zeros).</p>
							<VaultFunctionWithInput
							  drizzle={this.props.drizzle}
							  drizzleState={this.state.drizzleState}
							  value="lendvSPY"
							/>
					</div> 
				</div>
				<div class="clear"> </div>
			</div><br/><br/>
			
			<div class="main-w3lsrow">
		
				<div class="login-form login-form-left"> 
					<div class="agile-row">
						<h3>Repay vSPY to your CTV</h3> 
						<p>Return vSPY token to your vault in order to unlock ETH. Enter in the field below the number of vSPY you'd like to return, multipled by 10^18 and expressed as an integer. For example, to return 0.031 tokens, put in 31000000000000000 (three then one then 15 zeros).</p>
						<VaultFunctionWithInput
						  drizzle={this.props.drizzle}
						  drizzleState={this.state.drizzleState}
						  value="repayvSPY"
						/>
					</div> 
				</div>  
				
				<div class="login-form agileits-right"> 
					<div class="agile-row">
						<h3>Liquidate Noncompliant Vault</h3> 
						<p>Use the tool below to liquidate vaults that are not in compliance.</p>
							<LiquidateCTV
							  drizzle={this.props.drizzle}
							  drizzleState={this.state.drizzleState}
							/>
					</div> 
				</div>
				<div class="clear"> </div>
			</div><br/><br/><hr/>
			
		
	
			<div class="main-w3lsrow">
				<h2>Claim Your Vote for Version 2</h2>
				<p>This smart contract lets you deposit ETH to prove your interest in version 2.  Claiming your vote involves depositing ETH into the smart contract address below, which you (and only you!) can fully withdraw at any time.  It is fully reversible, yet shows the ItoVault team your strong interet in using the product.  You can Claim Your Vote for Version 2 if you are loving using Version 1, or you're not ready for Version 1 yet but would love Version 2.  Depositing ETH in this Smart Contract records both the amount deposited and a date, expressing the priority if your vote.  While no rewards at all are planned or guaranteed for voters, governance may decide in the future to give airdrops, allow early access to products, etc, as a show of gratitude for voters.</p>
		
				<div class="login-form login-form-left"> 
					<div class="agile-row">
						<h3>Claim Your Vote Address</h3> 
						<p class="output-value">{this.props.drizzle.contracts.ClaimPriorityDate.address}</p>
						<p>Send ETH to the address above to automatically Claim your Vote for Version 2!  The above smart contract receive() function will automatically credit you.  You and only you can withdraw the claim.</p>
					</div> 
				</div>  
				
				<div class="login-form agileits-right"> 
					<div class="agile-row">
						<h3>Wei in your Claim Contract</h3> 
						<p class="output-value">
							<ReadClaimFunction 
							  drizzle={this.props.drizzle}
							  drizzleState={this.state.drizzleState}
							  value="weiDeposited"
							  dictkey={this.state.drizzleState.accounts[0]}
							/>
						</p>
						<p>Your Claim Your Vote contract has the above number of Weis deposited.  (10^18 Wei = 1 ETH).</p>
					</div> 
				</div>
				<div class="clear"> </div>
			</div><br/><br/>
			<div class="main-w3lsrow">
				<div class="login-form login-form-left"> 
					<div class="agile-row">
						<h3>Withdraw Your Claim</h3> 
						<p>To withdraw your Claim your Vote amount, please enter the integer number of Weis you want to withdraw below.  For example, if you want to withdraw .45 ETH, put in 450000000000000000 (four then five then 16 zeros).</p>
						<ClaimFunctionWithInput
						  drizzle={this.props.drizzle}
						  drizzleState={this.state.drizzleState}
						  value="withdrawClaim"
						/>

					</div> 
				</div>  
				
				<div class="clear"> </div>
			</div><br/><br/><hr/>
		
		</div>
		
		
		

		
		

		
      </div>
    );
  }
}
export default App;
